import { LaravelResponse, createCrudService, keyToUrl } from "@dgs/core";
import axios from "axios";
import {
	FilterIndexResource,
	FilterOptionResource,
	FilterSaveRequest,
	FilterUpdateResource,
	FilterableEntity,
	FilterableFieldResource,
} from "../filters/filterTypes";

const baseKey = ["filters"];
const filterCrudService = createCrudService<
	FilterIndexResource,
	FilterOptionResource,
	FilterUpdateResource,
	FilterSaveRequest
>(baseKey);
const getOperatorOptionsKey = [...baseKey, "fields"];

export const filterService = {
	...filterCrudService,
	getOperatorOptionsKey,
	getFilterableFields: (entity: FilterableEntity) =>
		axios.get<LaravelResponse<FilterableFieldResource[]>>(keyToUrl(getOperatorOptionsKey), {
			params: {
				entity: entity,
			},
		}),
};
